module.exports = __webpack_public_path__ + "img/time-clock.ce84d4cb.svg";